<script setup>
/**
 * Este componente gestiona el enlace que abre el modal basado en un componente Vue.
 * Utilizamos ModalRemotoLayout que utiliza el modal estandar de Bootstrap.
 *
 * Básicamente se encarga de gestionar el show y hide del modal de bootstrap y los eventos
 * eventos del modal para poder usarlos directamente en las páginas con <cifra-modal-componente-vue>
 */
/* global $ */
import {
  computed, provide, ref, useTemplateRef, watch,
} from 'vue';

// import ResponderSolicitudForm from '@/apps/cifra/fichajes/ResponderSolicitudForm.vue';

import ModalBootstrapLayout from '../ModalBootstrapLayout.vue';

// TODO: Esta carga de componentes debería de ser dinámica pero aún no sé cómo
// hacerlo y necesitamos avanzar. Vewr la rama de "feature/fichajes#6139" que hay ejemplos de uso
// cuando se necesite reactivar esta funcionalidad
const componentesValidos = {
  // ResponderSolicitudForm,
};

const props = defineProps({
  componente: { type: [Object, String], required: true },
  // Datos que se le pasarán al componente como si fueran atributos normales por lo que
  // el componente los recibirá como props
  dataComponente: { type: Object, default: () => {} },
  // Para controlar si se hace visible o no
  modelValue: { type: Boolean, default: false },
});

const emits = defineEmits(['update:modelValue']);

const modal = useTemplateRef('modal');
const $modal = ref(null);
const showModal = ref(props.modelValue);

const componenteCargado = computed(() => (
  componentesValidos[props.componente]
));

function controlEventosModalBootstrap() {
  $modal.value.on('shown.bs.modal', (e) => {
    // TODO: Muy mejorable esta búsqueda
    $(e.currentTarget).find('input:first-child').trigger('focus');
  });
  $modal.value.on('hidden.bs.modal', () => {
    // Limpiamos el contenido porque si deja elementos en el modal oculto con algún id,
    // habrá interferencias entre modales. (Edición de entrevistas)
    showModal.value = false;
    emits('update:modelValue', false);
  });
}

function showModalBootstrap() {
  $modal.value = $(modal.value.$el);
  controlEventosModalBootstrap();
  $modal.value.modal('show');
}

function hideModalBootstrap() {
  $modal.value?.modal('hide');
}

watch(() => props.modelValue, (value) => {
  // Si es true, mostraremos el modal cuando se haya montado el layout en layoutCargado
  showModal.value = value;
  if (!value) {
    hideModalBootstrap();
  } else {
    showModalBootstrap();
  }
});

function mostrarModal() {
  showModal.value = true;
  showModalBootstrap();
}

function cerrarModal() {
  hideModalBootstrap();
  // Esto se hace mejor cuando termina la animación para que no se vean saltos
  // Arriba en controlEventosModalBootstrap se hace
  // showModal.value = false;
}

// Proveemos métodos para que desde el componente hijo puedan manipular el modal
provide('cerrarModal', cerrarModal);

</script>

<template>
  <span class="clickable" @click.prevent="mostrarModal()">
    <slot></slot>
  </span>
  <Teleport to="body">
    <ModalBootstrapLayout
      ref="modal"
      v-bind="$attrs"
    >
      <component
        :is="componenteCargado"
        v-if="showModal"
        v-bind="dataComponente"
      ></component>
      <div v-if="!componenteCargado" class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i>
        No se encontró el componente {{ componente }}
      </div>
    </ModalBootstrapLayout>
  </Teleport>
</template>
